import "./HeroImgStyles.css";

import BGImg from "../assets/back1.jpeg";

const HeroImg = () => {
  return (
    <div className="hero">
      <div className="mask">
        <img className="bg-img" src={BGImg} alt="background" />
      </div>
      <div className="content">
        <p>Hey there! I'm</p>
        <h1>Yeshas Nath</h1>
        <h3 className="typewriter">Welcome to my portfolio</h3>
        {/* <div>
                <Link to="/projects" className="btn">Projects</Link>
                <Link to="/contact" className="btn btn-light">Contact</Link>
            </div>
        <div className="resumebtn">
          <a
            href="https://drive.google.com/file/d/1ahgbB9j9RcEjgN3kriPta7qkfILX1VkE/view?usp=sharing"
            target="_blank"
          >
            <button className="btn">View my Resume</button>
          </a>
        </div> */}
      </div>
    </div>
  );
};

export default HeroImg;
